import {Theme, createStyles} from '@material-ui/core';

const commonTitleStyles = (theme: Theme) => ({
	fontSize: theme.typography.pxToRem(16),
	lineHeight: theme.typography.pxToRem(24),
});

const commonXSTitleStyles = (theme: Theme) => ({
	fontSize: theme.typography.pxToRem(10),
	lineHeight: theme.typography.pxToRem(14),
});

const commonSMTitleStyles = (theme: Theme) => ({
	fontSize: theme.typography.pxToRem(14),
	lineHeight: theme.typography.pxToRem(18),
});

export const teamMemberBlockStyles = (theme: Theme) =>
	createStyles({
		root: {
			width: '100%',
		},
		imageBox: {
			overflow: 'hidden',
			lineHeight: 0,
		},
		image: {
			overflow: 'hidden',
			width: '100%',
		},
		titleIn: {
			...commonXSTitleStyles(theme),
			position: 'absolute',
			paddingTop: theme.spacing(1.5),
			paddingLeft: theme.spacing(2),
			whiteSpace: 'pre-line',
			color: theme.palette.common.white,
			textShadow: '0 0 10px #000',

			[theme.breakpoints.up('sm')]: {
				...commonSMTitleStyles(theme),
			},
			[theme.breakpoints.up('md')]: {
				...commonTitleStyles(theme),
			},
			[theme.breakpoints.down('sm')]: {
				paddingTop: theme.spacing(0.75),
				paddingLeft: theme.spacing(1),
				wordSpacing: '100vw',
			},
		},
		title: {
			...commonXSTitleStyles(theme),
			whiteSpace: 'pre-line',
			[theme.breakpoints.up('sm')]: {
				...commonSMTitleStyles(theme),
			},
			[theme.breakpoints.up('md')]: {
				...commonTitleStyles(theme),
			},
			[theme.breakpoints.down('xs')]: {
				paddingTop: theme.spacing(1),
			},
		},
	});
